import {  Dispatch, SetStateAction, useEffect, useState } from "react";
import { IHTMLDiv } from "../interfaces/InputsInterfacesType1";
import { IInputValidationItemController } from "../../../../factorys/inputvalidation/interfaces/InputValidationInterfaces";



/**
 * works for;
 * TextInput, SelectInput
 */
interface IProps<T> {
  value: T | undefined;
  disabled?: boolean | undefined;
  classNameInput?: string;
  classNameFrame?: string;
  disabledClass: string
}
interface IReturnProps<T> extends IInputValidationItemController {
  blur: boolean; setBlur: Dispatch<SetStateAction<boolean>>;
  setRefFrame: (it: IHTMLDiv | null) => void,
  refInput: HTMLInputElement | null, setRefInput: (it: HTMLInputElement | null) => void,
  value: T | undefined, setValue: Dispatch<T>
}
export const DatePickerControllerType1 = <T>(props: IProps<T>): IReturnProps<T> => {
  
  const tag = " DatePickerControllerType1";
  //console.log(tag + " START");

  //states
  const [value, setValue] = useState<T | undefined>(props.value);
  useEffect(() => {
    //console.log("value: " +value)
  }, [value]);
 
  const [blur, setBlur] = useState<boolean>(false);

  //refs
  let refFrame: IHTMLDiv | null = null;
  function setRefFrame(it: IHTMLDiv | null) {
    try {
      if (it == null) return;
      refFrame = it;
      setDisabled(props.disabled);
    } catch (e) {}
  }

  let refInput: HTMLInputElement | null = null;
  function setRefInput(it: HTMLInputElement | null) {
    try {
      if (it == null) return;
      refInput = it;
      //refInput.addEventListener("input",(e) =>inputEvent(e))
      setDisabled(props.disabled);
    } catch (e) {}
  }
  //states

  //#region listener
  const inputEvent = (ev: any) => {
    try {
      const e = ev// as ChangeEvent<HTMLInputElement>;
      if(e == null) return;
      const value = e.target.value
      const pattern=/(\d{4})-(\d{2})-(\d{2})/;
   
      if(value.match(pattern)) {
        e.target.style.borderBlockColor ="green"
        return;
      } else {
        e.target.style.borderBlockColor ="red" 
            //ev.target.value = ""
        return;
      }
    }catch(e) {

    }

  }
  //#endregion

  //init
  useEffect(() => {
    //console.log(tag + " => onMount");
    setDisabled(props.disabled);
    //setDisabled(true)
    return () => {
      //console.log(tag + " => onUnmount");
    };
  }, []);


  useEffect(() => {
    try {
      setDisabled(props.disabled);
    } catch (e) {}
  }, [props.disabled]);


  function setDisabled(disabled: boolean = true) {
    if(refFrame != null) {
      try {
        refFrame.className = disabled ? (props.classNameFrame + " " + props.disabledClass) : props.classNameFrame!!;
      } catch (e) {
        refFrame!!.className = disabled ? (props.disabledClass) : "";
      }
    }

    if(refInput != null) {
      try {
          refInput.disabled = disabled;
          refInput.className = disabled ? (props.classNameInput!! + " " + props.disabledClass) : props.classNameInput!!;
        } catch (e) {
          refFrame!!.className = disabled ? (props.disabledClass) : "";
        } 
    }
  }

  return { 
    blur, setBlur,
    setRefFrame, 
    refInput, setRefInput,
    value, setValue
  };
}